import { render } from "./AddUser.vue?vue&type=template&id=71eecfcd"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import "./AddUser.vue?vue&type=style&index=0&id=71eecfcd&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__